var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-panel__filter-slider" },
    [
      _c("div", { staticClass: "search-panel__slider-inputs" }, [
        _c("div", { staticClass: "search-panel__slider-input-wrap" }, [
          _c(
            "label",
            {
              staticClass: "search-panel__slider-input-prefix",
              attrs: { for: "spPriceFrom" }
            },
            [_vm._v("от")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueMin,
                expression: "valueMin"
              }
            ],
            ref: "inputMin",
            staticClass: "search-panel__slider-input",
            attrs: { id: "spPriceFrom" },
            domProps: { value: _vm.valueMin },
            on: {
              focusout: _vm.focusOutMin,
              keypress: _vm.isNumber,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueMin = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "search-panel__slider-input-wrap" }, [
          _c(
            "label",
            {
              staticClass: "search-panel__slider-input-prefix",
              attrs: { for: "spPriceTo" }
            },
            [_vm._v("до")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueMax,
                expression: "valueMax"
              }
            ],
            ref: "inputMax",
            staticClass: "search-panel__slider-input",
            attrs: { id: "spPriceTo" },
            domProps: { value: _vm.valueMax },
            on: {
              focusout: _vm.focusOutMax,
              keypress: _vm.isNumber,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueMax = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "search-panel__slider-input-suffix" }, [
            _vm._v("₽")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("VueSlider", {
        ref: "slider",
        attrs: {
          silent: true,
          dotSize: 0,
          contained: true,
          tooltip: "none",
          min: _vm.slider.min,
          max: _vm.slider.max,
          interval: _vm.slider.interval
        },
        on: { "drag-start": _vm.dragStart, "drag-end": _vm.dragEnd },
        model: {
          value: _vm.sliderValue.value,
          callback: function($$v) {
            _vm.$set(_vm.sliderValue, "value", $$v)
          },
          expression: "sliderValue.value"
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: _vm.slider.name + "[min]" },
        domProps: { value: _vm.slider.value[0] }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: _vm.slider.name + "[max]" },
        domProps: { value: _vm.slider.value[1] }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }